import React, { useCallback } from 'react';
import Modal from 'react-responsive-modal';
import { useBeforeUnload, useBlocker } from 'react-router-dom';
import './UnsavedChangesPrompt.css';

const UnsavedChangesPrompt = ({ cancelText, confirmText, message, when }) => {
  const blocker = useBlocker(when);

  useBeforeUnload(useCallback((event) => {
    if (when) {
      event.preventDefault();
    }
  }, [when]));

  const stayOnPage = () => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
  };

  const leavePage = () => {
    if (blocker.state === 'blocked') {
      blocker.proceed();
    }
  };

  return (
    <Modal open={blocker.state === 'blocked'}
           onClose={stayOnPage}
           showCloseIcon={false}
           center>
      <div className="unsaved-changes-prompt">
        <div>{message}</div>
        <div className="unsaved-changes-prompt__actions">
          <button type="button"
                  onClick={leavePage}
                  className="unsaved-changes-prompt__button">
            {confirmText}
          </button>
          <button type="button"
                  onClick={stayOnPage}
                  className="unsaved-changes-prompt__button unsaved-changes-prompt__button--cancel">
            {cancelText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UnsavedChangesPrompt;
